import Button from '@halo/components/button';
import Text from '@halo/components/text';
export default [Button, Text];
